import { useQueryParams } from '@terminal/hooks/use-query-params/useQueryParams';
import {
  DRAWER_PARAM_KEYS,
  getCleanDrawerParams,
  queryKeys,
  queryValues,
} from '@terminal/routes/query-params';
import { getCalendarQuarterInfo } from '@terminal/views/theme-overview/tab-content/earnings/utils/utils';

import type { CalendarQuarterPeriod } from './utils';

const toCalendarQuarterPeriod = (
  reportingDate: string | null
): CalendarQuarterPeriod | undefined => {
  if (!reportingDate) {
    return undefined;
  }

  const { quarter, year, startDate } = getCalendarQuarterInfo(
    new Date(reportingDate)
  );

  return {
    quarter,
    year,
    reporting_date: startDate.toISOString(),
  };
};

export const useThemeEarningsSummaryDrawer = () => {
  const { deleteQueryParam, params, setQueryParams } = useQueryParams();
  const isThemeEarningsDrawerOpen =
    params[queryKeys.activeDrawer] === queryValues.themeEarningsDrawer;
  const isNestedEarningsInsightDrawerOpen =
    params[queryKeys.activeDrawer] === queryValues.earningsInsightDrawer &&
    params[queryKeys.parentDrawer] === queryValues.themeEarningsDrawer;
  const isOpen = isThemeEarningsDrawerOpen || isNestedEarningsInsightDrawerOpen;
  const themeId = isOpen ? (params[queryKeys.themeId] ?? undefined) : undefined;
  const reportingDateParam = isOpen ? params[queryKeys.reportingDate] : null;
  const reportingPeriod = toCalendarQuarterPeriod(reportingDateParam);

  const openDrawer = (selectedThemeId: string, reportingDate?: string) => {
    setQueryParams({
      ...getCleanDrawerParams(),
      [queryKeys.drawerExpanded]: undefined,
      [queryKeys.activeDrawer]: queryValues.themeEarningsDrawer,
      [queryKeys.themeId]: selectedThemeId,
      [queryKeys.reportingDate]: reportingDate?.slice(0, 10),
    });
  };

  const closeDrawer = () => {
    deleteQueryParam([...DRAWER_PARAM_KEYS, queryKeys.drawerExpanded]);
  };

  return {
    openDrawer,
    drawerProps: {
      isOpen: !!themeId,
      isNestedDrawerOpen: isNestedEarningsInsightDrawerOpen,
      onClose: closeDrawer,
      themeId,
      reportingPeriod,
    },
  };
};
